/**
 * Footer Component
 * Application footer with copyright and links
 */

import { Layout } from 'antd';
import config from '../../../config/environment.config';
import './Footer.scss';

const { Footer: AntFooter } = Layout;

/**
 * Footer Component
 */
export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <AntFooter className="app-footer">
      <div className="app-footer__content">
        <div className="app-footer__copyright">
          © {currentYear} Healthcare Management System. All rights reserved.
        </div>
        
        <div className="app-footer__links">
          <a href="/privacy" className="app-footer__link">
            Privacy Policy
          </a>
          <a href="/terms" className="app-footer__link">
            Terms of Service
          </a>
          <a href="/support" className="app-footer__link">
            Support
          </a>
        </div>

        <div className="app-footer__version">
          Version {config.appVersion}
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;

